import { render, staticRenderFns } from "./PreviewSettingThemeColor.vue?vue&type=template&id=427a8ec2&lang=pug"
import script from "./PreviewSettingThemeColor.vue?vue&type=script&lang=js"
export * from "./PreviewSettingThemeColor.vue?vue&type=script&lang=js"
import style0 from "./PreviewSettingThemeColor.vue?vue&type=style&index=0&id=427a8ec2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports